export default function (merchantsData) {

	return {
		merchants: [...merchantsData]
	};
}


// WEBPACK FOOTER //
// ./src/Merchants/Model/merchantsModelFactory.js